export default function initTables() {
  document.addEventListener('readystatechange', async (event: Event) => {
    const target = event.target as Document;
    if (target && target.readyState === 'complete') {
      const tables = document.querySelectorAll('.table-wrapper table');
      tables.forEach((table) => {
        const headers = Array.from(table.querySelectorAll('thead th')).map(
          (tableHead) => tableHead.textContent?.trim(),
        );
        if (headers.length > 0) {
          table.classList.add('tableWithHeaders');
          table.querySelectorAll('tbody tr').forEach((row) => {
            row.querySelectorAll('td').forEach((td, i) => {
              const originalContent = td.innerHTML;
              const label = headers[i] || `Column ${i + 1}`;

              // eslint-disable-next-line no-param-reassign
              td.innerHTML = `
                    <span class="td-label">${label}</span>
                    <span class="td-value">${originalContent}</span>
                    `;
            });
          });
        }
      });
    }
  });
}
